import api from "../api";

export interface UpdateSettingsPayload {
  messageTitle: string;
  emailBody?: string;
  /** null mantém o valor atual; false desliga a assinatura automática. */
  autoSignEnabled?: boolean | null;
  /** String base64 do PNG. String vazia remove a assinatura salva; undefined mantém a atual. */
  autoSignSignature?: string | null;
  autoSignDocument?: string | null;
}

export const updateMessageTitleGat = async (
  userId: string,
  messageTitle: string,
  newEmailBody?: string,
  autoSign?: Pick<
    UpdateSettingsPayload,
    "autoSignEnabled" | "autoSignSignature" | "autoSignDocument"
  >
): Promise<boolean> => {
  const result = await api.put(`/settings`, {
    userId,
    messageTitle,
    EmailBody: newEmailBody,
    ...(autoSign ?? {}),
  });
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const getMessageTitleByUserIdGat = async (userId: string): Promise<any> => {
  const result = await api.get(`/settings?userId=${userId}`);
  if (result.status === 200) {
    return result.data;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export interface AutoSignStatus {
  enabled: boolean;
  hasDocument: boolean;
}

export const getAutoSignStatusGat = async (
  email: string
): Promise<AutoSignStatus> => {
  const result = await api.get(`/users/auto-sign?email=${encodeURIComponent(email)}`);
  if (result.status === 200) {
    return result.data?.data ?? { enabled: false, hasDocument: false };
  }
  throw new Error("Não foi possível consultar a assinatura automática");
};
